import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { GearFieldWrapper } from '../GearFieldWrapper';

export const FormDropDownList: React.FC<FieldRenderProps & { dataUsesTranslations?: boolean }> = fieldRenderProps => {
  const { disabled } = fieldRenderProps;
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  React.useEffect(() => {
    const handleScrollOutside = (event: Event) => {
      if (!isOpen) {
        return;
      }

      const dropdownElement = document.querySelector('.k-animation-container');
      if (dropdownElement && dropdownElement.contains(event.target as Node)) {
        return;
      }

      setIsOpen(false);
    };

    const controller = new AbortController();
    document.addEventListener('wheel', handleScrollOutside, { signal: controller.signal });
    document.addEventListener('scroll', handleScrollOutside, { signal: controller.signal, capture: true });

    return () => {
      controller.abort();
    };
  }, [isOpen, setIsOpen]);

  let valueForField = fieldRenderProps.value;
  if (fieldRenderProps.dataUsesTranslations && fieldRenderProps.dataItemKey && fieldRenderProps.value) {
    const key = fieldRenderProps.dataItemKey as string;
    valueForField = fieldRenderProps.data.find(
      (d: { [key: string]: unknown }) => d[key] === (fieldRenderProps.value as { [key: string]: unknown })[key]
    );
  }

  return (
    <GearFieldWrapper {...fieldRenderProps}>
      <DropDownList
        {...fieldRenderProps}
        label={undefined}
        validationMessage={fieldRenderProps.validationMessage || undefined}
        value={valueForField}
        opened={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        disabled={disabled}
      />
    </GearFieldWrapper>
  );
};
